import { useQuery } from '@tanstack/react-query';
import { getTenantDetails } from "../orgPanelApiCalls";
import { useStore } from "../appStore"

const key = 'organizationTenant';

const useGetTenantQuery = () => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    return useQuery({ queryKey: [key], queryFn: () => getTenantDetails(orgId) })
}

export { useGetTenantQuery, key };